function collect (success, failure) {
  return (r) => {
    const errors = []
    const data = []
    for (let i = 0; i !== r.length; ++i) {
      const e = r[i].data.err
      if (e != null) {
        const req = JSON.parse(r[i].config.data)
        errors.push(`<u>${req.dset}</u><br>${e}<br><br>`)
      } else {
        data.push(r[i].data)
      }
    }

    if (errors.length > 0) {
      failure(errors)
    } else {
      success(data, r)
    }
  }
}

function awaitAll (promises, success, failure) {
  Promise.all(promises).then(
    collect(success, failure)
  ).catch(e => failure([e.data ? e.data : e]))
}

export default {
  awaitAll
}
